module.exports = __webpack_public_path__ + "static/media/camera-tip.05875de8.svg";